// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateNewTransfer = data => ({
    data,
    type: actions.UPDATE_NEW_TRANSFER_SUCCESS
});



// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/update-new-transfer.js